<template>
  <div
    class="td col"
    :class="{
      [`col-${cols}`]: !!cols
    }"
    @click="onClick"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'TableData',
  props: {
    cols: {
      type: [Number, String],
      default: ''
    }
  },
  methods: {
    onClick (e) {
      this.$parent.$emit('row:selected', e)
    }
  }
}
</script>
